export const CONFIG = [
    {
        domains: ['gmail.com', 'googlemail.com'],
        label: 'GMail',
        url: 'https://mail.google.com/',
    },
    {
        domains: ['gmx.de', 'gmx.net'],
        label: 'GMX',
        url: 'https://www.gmx.net/',
    },
    {
        domains: ['t-online.de'],
        label: 't-online.',
        url: 'https://www.t-online.de/auth/',
    },
    {
        domains: ['web.de'],
        label: 'WEB.DE',
        url: 'https://web.de/email/',
    },
    {
        domains: [
            'aol.com',
            'aol.de',
            'aim.com',
            'aol.co.uk',
            'cs.com',
        ],
        label: 'AOL',
        url: 'https://login.aol.com/',
    },
    {
        domains: [
            'hotmail.com',
            'hotmail.de',
            'hotmail.co.uk',
            'outlook.de',
            'outlook.com',
            'hotmail.it',
            'hotmail.fr',
            'msn.com',
            'live.co.uk',
            'live.nl',
            'live.com',
            'outlook.fr',
        ],
        label: 'Outlook',
        url: 'https://outlook.live.com/',
    },
    {
        domains: [
            'yahoo.de',
            'yahoo.com',
            'yahoo.fr',
            'yahoo.gr',
            'yahoo.no',
        ],
        label: 'yahoo!',
        url: 'https://login.yahoo.com/',
    },
    {
        domains: ['freenet.de'],
        label: 'freenet',
        url: 'https://www.freenet.de/',
    },
    {
        domains: ['online.de', 'onlinehome.de'],
        label: 'IONOS',
        url: 'https://id.ionos.com/',
    },
    {
        domains: [
            'yahoo.de',
            'yahoo.com',
            'yahoo.fr',
            'yahoo.gr',
            'yahoo.no',
        ],
        label: 'yahoo!',
        url: 'https://login.yahoo.com/',
    },
    {
        domains: ['me.com', 'icloud.com'],
        label: 'iCloud',
        url: 'https://www.icloud.com/',
    },
    {
        domains: ['sky.com'],
        label: 'Sky Yahoo',
        url: 'https://www.sky.com/signin/email',
    },
    {
        domains: ['skynet.be'],
        label: 'pickx',
        url: 'https://skynet.be/',
    },
    {
        domains: ['inbox.lv'],
        label: 'inbox.lv',
        url: 'https://www.inbox.lv/',
    },
    {
        domains: ['wp.pl'],
        label: 'WP',
        url: 'https://poczta.wp.pl/login/login.html',
    },
    {
        domains: ['interia.pl'],
        label: 'interia',
        url: 'https://poczta.interia.pl/',
    },
    {
        domains: ['yahoo.co.uk'],
        label: 'yahoo!',
        url: 'https://login.yahoo.com/',
    },
    {
        domains: ['gmx.com'],
        label: 'GMX',
        url: 'https://www.gmx.com/',
    },
    {
        domains: ['wanadoo.fr'],
        label: 'orange',
        url: 'https://www.orange.fr/portail',
    },
    {
        domains: ['o2.pl'],
        label: 'o2',
        url: 'https://www.o2.pl/',
    },
    {
        domains: ['online.nl'],
        label: 'online.nl',
        url: 'https://webmail.online.nl/',
    },
    {
        domains: ['mail.de'],
        label: 'mail.de',
        url: 'https://mail.de',
    },
    {
        domains: ['voo.be'],
        label: 'VOO',
        url: 'https://login.myvoo.be/sso/login',
    },
    {
        domains: ['t-online.hu'],
        label: 'Telekom',
        url: 'https://webmail.telekom.hu/login.php',
    },
    {
        domains: ['yandex.ru'],
        label: 'Yandex',
        url: 'https://passport.yandex.com/',
    },
    {
        domains: ['op.pl'],
        label: 'Onet',
        url: 'https://konto.onet.pl/',
    },
    {
        domains: ['szm.com'],
        label: 'SZM',
        url: 'https://szm.com/',
    },
    {
        domains: ['gmx.ch'],
        label: 'GMX',
        url: 'https://www.gmx.ch/',
    },
    {
        domains: ['arcor.de'],
        label: 'Vodafone',
        url: 'https://live.vodafone.de/login',
    },
    {
        domains: ['email.de'],
        label: 'WEB.DE',
        url: 'https://web.de/email/',
    },
    {
        domains: ['telenet.be'],
        label: 'Telenet',
        url: 'https://login.prd.telenet.be/openid/login',
    },
];
